import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import client from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [amount, setAmount] = useState(null);
  const { refresh } = useCart();

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0; let stop = false;
    const poll = async () => {
      if (stop) return;
      attempts += 1;
      try {
        const { data } = await client.get(`/payments/status/${sessionId}`);
        setAmount(data.amount);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (attempts > 20) { setStatus("timeout"); return; }
      } catch {}
      setTimeout(poll, 2000);
    };
    poll();
    return () => { stop = true; };
  }, [sessionId, refresh]);

  return (
    <div className="container-editorial mt-14">
      <div className="max-w-2xl mx-auto py-16 text-center">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto text-[#2C402E]"/>
            <p className="label-uppercase text-[#B24C38] mt-6">Payment confirmed</p>
            <h1 className="font-serif text-5xl md:text-6xl tracking-tighter mt-3" data-testid="payment-success-heading">
              Thank you for your order.
            </h1>
            {amount && <p className="font-serif text-3xl mt-6">${Number(amount).toFixed(2)}</p>}
            <p className="text-[#4A4A4A] mt-4">You'll receive a confirmation email shortly. Every atelier is packing your pieces now.</p>
            <div className="mt-10 flex gap-4 justify-center">
              <Link to="/orders" className="btn-outline-ink">View order</Link>
              <Link to="/" className="btn-terracotta">Return home →</Link>
            </div>
          </>
        ) : status === "timeout" ? (
          <>
            <p className="label-uppercase text-[#B24C38]">Still processing</p>
            <h1 className="font-serif text-4xl mt-3">Your payment is still being confirmed.</h1>
            <p className="text-[#4A4A4A] mt-4">Please refresh in a moment, or check your inbox for confirmation.</p>
          </>
        ) : (
          <>
            <p className="label-uppercase text-[#B24C38]" data-testid="payment-status-polling">Confirming your payment…</p>
            <h1 className="font-serif text-4xl mt-3">One moment.</h1>
            <div className="mt-8 h-1 w-32 mx-auto bg-[#EAE5D9] overflow-hidden">
              <div className="h-full w-1/3 bg-[#B24C38] animate-[slide_1.2s_ease_infinite]"/>
            </div>
            <style>{`@keyframes slide { 0% { transform: translateX(-100%);} 100% { transform: translateX(300%);} }`}</style>
          </>
        )}
      </div>
    </div>
  );
}
